import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useOrganizer } from '@/hooks/useOrganizers';
import { useRaces } from '@/hooks/useRaces';
import { DEFAULT_ORGANIZER_LOGO, DEFAULT_RACE_IMAGE } from '@/config/constants';
import OrganizerDetailView from './organizerdetailpage.view';

const OrganizerDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: organizerData, isLoading: orgLoading } = useOrganizer(id);
  const { data: allRaces = [], isLoading: racesLoading } = useRaces();

  const loading = orgLoading || racesLoading;

  const organizer = useMemo(() => {
    if (!organizerData) return null;
    return {
      id: organizerData.id,
      name: organizerData.name,
      description: organizerData.description,
      logo: organizerData.logo || DEFAULT_ORGANIZER_LOGO,
      website: organizerData.website
    };
  }, [organizerData]);

  const organizerEvents = useMemo(() => {
    return allRaces
      .filter(race => race.adminId === parseInt(id, 10))
      .map(race => ({
        id: race.id,
        title: race.name,
        subtitle: '',
        location: race.location,
        organizer: race.admin?.name || 'Unknown',
        organizerId: race.adminId,
        date: race.startDate?.split('T')[0] || '',
        time: race.startDate?.split('T')[1]?.substring(0, 5) || '',
        image: DEFAULT_RACE_IMAGE,
        registrationUrl: `/events/${race.id}/register`,
        status: race.status?.toLowerCase() || 'upcoming',
        description: race.description || ''
      }));
  }, [allRaces, id]);

  return (
    <OrganizerDetailView
      organizer={organizer}
      organizerEvents={organizerEvents}
      loading={loading}
      navigate={navigate}
    />
  );
};

export default OrganizerDetailPage;
